import React from "react";
import { Button, Tag } from "antd";
import { useEffect, useState } from "react";
import { departmentService } from "Services/AdminServices/Organization/DepartmentService";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const useDepartments = () => {
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingDepartment, setEditingDepartment] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });

  const fetchDeaprtments = async () => {
    setLoading(true);
    try {
      const data = await departmentService.fetchDeaprtments();
      setDepartments(data || []);
    } catch (eror) {
      console.error("error", eror);
    } finally {
      setLoading(false);
    }
  };

  const createDepartment = async (payload) => {
    try {
      await departmentService.createDepartment(payload);
    } catch (err) {
      throw err;
    }
  };

  const updateDepartment = async (payload) => {
    try {
      const response = await departmentService.updateDepartment(payload);
    } catch (error) {
      console.error("Error in updating deaprtment", error);
    }
  };

  useEffect(() => {
    fetchDeaprtments();
  }, []);

  const columns = [
    {
      title: "ID",
      dataIndex: "publicId",
      key: "publicId",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text) => {
        const maxLength = 50;
        if (!text) return "-";
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
      },
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive) =>
        isActive ? <Tag color="green">Active</Tag> : <Tag color="red">In Active</Tag>,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <>
          <Button 
          icon={<EyeOutlined />} 
          style={{ marginRight: "8px" }}
          onClick={() => navigate(`/department-detail/${record.id}`)}
          />
          <Button
            icon={<EditOutlined />}
            style={{ marginRight: 8 }}
            onClick={() => {
              setEditingDepartment(record);
              setFormData({
                name: record.name,
                description: record.description,
              });
              setShowForm(true);
            }}
          />
        </>
      ),
    },
  ];
  return {
    loading,
    departments,
    columns,
    fetchDeaprtments,
    createDepartment,
    updateDepartment,
    editingDepartment,
    setEditingDepartment,
    showForm,
    setShowForm,
    formData,
    setFormData,
  };
};
